/* tslint:disable:variable-name */
import { isMobile } from 'is-mobile';
import * as React from 'react';
import smsLink from 'sms-link';
import { AnalyticsTrigger, Separator } from 'telia-front-react';

export interface GenerateSmsLinkProps {
  number: string;
  label: string;
  content: string;
}

const SmsLink: React.FC<GenerateSmsLinkProps> = (props: GenerateSmsLinkProps) => {
  const { number, label, content } = props;
  if (isMobile()) {
    return (
      <p>
        <Separator spacing="xxsmall" color="invisible" />
        <AnalyticsTrigger trigger={{ id: 'Link - Generate sms', callback: 'onClick' }}>
          <a href={smsLink({ phone: number, body: content })}>{label}</a>
        </AnalyticsTrigger>
      </p>
    );
  }
  return null;
};

SmsLink.displayName = 'SmsLink';
export default SmsLink;
